export default "__VITE_ASSET__CDuqDfJF__"